<h2 mat-dialog-title [transloco]="dialogTitle()"></h2>
<div mat-dialog-content>
  <mat-stepper
    linear
    #stepper
    [orientation]="(isHandset$ | async) ? 'vertical' : 'horizontal'"
    (selectionChange)="onStepSelectionChange($event)"
  >
    <mat-step
      [stepControl]="searchSetupFormGroup"
      [editable]="status === statusEnums.confirm"
    >
      <form [formGroup]="searchSetupFormGroup">
        <ng-template matStepLabel transloco="SEARCH_SETUP">{{
          'SEARCH_SETUP' | transloco
        }}</ng-template>
        <div class="content-size">
          <mat-form-field class="full-width">
            <mat-label transloco="SEARCHES"></mat-label>
            <mat-select
              formControlName="search"
              (selectionChange)="onSearchSelectionChange()"
              name="search"
            >
              @for (search of searches$ | async; track search.id) {
                <mat-option [value]="search">
                  {{ search.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!isSearchStatic) {
            <div>
              <button
                mat-button
                class="right-align"
                (click)="clickConfigureSearch()"
                [disabled]="!selectedSearch || isSearchStatic"
                transloco="SEARCH_CRITERIA"
              ></button>
            </div>
          }
        </div>
        @if (isSearchStatic) {
          <mat-card class="warning-card">
            <mat-card-header>
              <mat-card-title class="warning-title"
                ><mat-icon class="warning-icon">warning</mat-icon
                >{{ 'WARNING' | transloco }}</mat-card-title
              >
            </mat-card-header>
            <mat-card-content>{{
              'BULK_UPDATE_NO_SEARCH_INPUT_WARNING' | transloco
            }}</mat-card-content>
          </mat-card>
        }
      </form>
    </mat-step>
    <mat-step
      [stepControl]="setReplacementsFormGroup"
      [editable]="status === statusEnums.confirm"
    >
      <form [formGroup]="setReplacementsFormGroup">
        <ng-template matStepLabel>{{
          'REPLACEMENT_DATA' | transloco
        }}</ng-template>
        <ng-template matStepContent>
          <div class="content-size">
            <div>
              <h2 transloco="ARCHIVE_FIELDS"></h2>
              @for (field of archiveFields; track field.id) {
                @if (field.multiValue) {
                  <app-multi-value-field
                    [form]="getMultiValueFormArray(field.id)"
                    [field]="field"
                    [addRequiredValidator]="false"
                    (multiValueEntryAdded)="onMultiValueEntryAdded($event)"
                  ></app-multi-value-field>
                } @else {
                  <app-field
                    [form-control]="getReplacementFormControl(field.id)"
                    [field]="field"
                    [addRequiredValidator]="false"
                  ></app-field>
                }
              }
            </div>
            <div>
              <h2 transloco="DATABASE_FIELDS"></h2>
              @for (field of nonArchiveFields; track field.id) {
                @if (field.multiValue) {
                  <app-multi-value-field
                    [form]="getMultiValueFormArray(field.id)"
                    [field]="field"
                    [addRequiredValidator]="false"
                    (multiValueEntryAdded)="onMultiValueEntryAdded($event)"
                  ></app-multi-value-field>
                } @else {
                  <app-field
                    [form-control]="getReplacementFormControl(field.id)"
                    [field]="field"
                    [addRequiredValidator]="false"
                  ></app-field>
                }
              }
            </div>
          </div>
          <div>
            <mat-checkbox
              class="margin-top"
              (change)="overwriteSystemFieldsChange()"
            >
              <span transloco="OVERWRITE_SYSTEM_FIELDS"></span>
            </mat-checkbox>
          </div>
        </ng-template>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'UPDATE' | transloco }}</ng-template>
      @if (status === statusEnums.confirm) {
        <div>
          @if (jobIsInitializing()) {
            <div class="dialog-section text-center">
              <h2 transloco="INITIALIZING_BULK_UPDATE"></h2>
              <mat-progress-bar
                class="margin-bottom"
                mode="indeterminate"
                [value]="progress"
              >
              </mat-progress-bar>
              <span transloco="PREPARING_BULK_UPDATE"></span>
            </div>
          } @else {
            <div class="dialog-section">
              <h2 transloco="CONFIRM"></h2>
              <span
                >{{ totalDocuments }}
                {{ 'ARE_YOU_SURE_UPDATE' | transloco }}</span
              >
            </div>
          }
        </div>
      }
      @if (status === statusEnums.updating) {
        <div>
          <div class="dialog-section text-center">
            <h2 transloco="UPDATING_"></h2>
            <mat-progress-bar
              class="margin-bottom"
              [mode]="'determinate'"
              [value]="progress"
            >
            </mat-progress-bar>
            <span>{{ currentDocument }} / {{ totalDocuments }}</span>
          </div>
        </div>
      }
      @if (status === statusEnums.complete) {
        <div>
          <div class="dialog-section text-center">
            <h2 transloco="COMPLETE"></h2>
            <span>{{
              getCurrentUpdateText(currentDocument, totalDocuments)
            }}</span>
          </div>
          @if (errorInfo.erroredNumber) {
            <mat-card class="error-card">
              <mat-card-title class="error-title"
                >{{ errorInfo.erroredNumber }} Error(s) occurred</mat-card-title
              >
              <mat-card-content class="content-card-error">
                <ul>
                  @for (err of errorInfo.errorMessages; track err) {
                    <li>{{ err }}</li>
                  }
                </ul>
              </mat-card-content>
              @if (supportedOpenErrored()) {
                <mat-card-actions align="end">
                  <button mat-button (click)="onOpenErroredDocuments()">
                    <span transloco="OPEN_ERRORED"></span>
                  </button>
                </mat-card-actions>
              }
            </mat-card>
          }
        </div>
      }
      @if (status === statusEnums.cancel) {
        <div>
          <div class="dialog-section text-center">
            <h2 transloco="CANCELLED"></h2>
            <span>{{
              getCurrentUpdateText(currentDocument, totalDocuments)
            }}</span>
          </div>
        </div>
      }
    </mat-step>
  </mat-stepper>
</div>
<mat-dialog-actions>
  @if (status !== statusEnums.updating) {
    <button mat-button type="button" (click)="close()">
      <span transloco="CLOSE"></span>
    </button>
  }
  @if (status === statusEnums.updating) {
    <button mat-button type="button" (click)="clickCancel()">
      <span transloco="CANCEL"></span>
    </button>
  }
  @if (status === statusEnums.confirm) {
    <button mat-button (click)="reset(stepper)" type="button">
      <span transloco="RESET"></span>
    </button>
  }
  @if (
    stepper.selectedIndex > 0 &&
    status !== statusEnums.updating &&
    status !== statusEnums.complete &&
    status !== statusEnums.cancel
  ) {
    <button
      mat-button
      (click)="clickBack(stepper)"
      type="button"
      transloco="BACK"
    ></button>
  }
  <span class="spacer"></span>
  @if (stepper.selectedIndex < 1) {
    <button
      mat-button
      type="button"
      (click)="clickNext(stepper)"
      [disabled]="!showSearchParameters"
      transloco="NEXT"
    ></button>
  }
  @if (stepper.selectedIndex === 1 && jobId === '') {
    <button
      mat-button
      type="button"
      [disabled]="
        !setReplacementsFormGroup.dirty || setReplacementsFormGroup.invalid
      "
      (click)="stepper.next()"
      transloco="UPDATE"
    ></button>
  }
  @if (
    stepper.selectedIndex === 2 &&
    jobId !== '' &&
    status === statusEnums.confirm
  ) {
    <button
      mat-button
      (click)="startBulkSearchUpdate()"
      [disabled]="totalDocuments === 0"
      transloco="CONFIRM"
    ></button>
  }
</mat-dialog-actions>
